import React, { Component } from "react";
import { connect } from "react-redux";

import { Table, Input } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import {
  req_list_ssp_school_college_handle,
  req_downloadfile_ssp_school_college_handle,
} from "../../api";

class CollegeHandleStatisticesList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    data: [],
  };

  componentWillMount() {
    this.api_item_list();
  }

  //////////
  api_item_list = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_college_handle(
      userCode,
      userLevel,
      planAcademicYear,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
      console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
      });
    }
  };

  api_downloadfile_items = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    // download file data
    const fileUrl = await req_downloadfile_ssp_school_college_handle(
      userCode,
      userLevel,
      planAcademicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  //////////
  handle_data_refresh = () => {
    //this.api_list_studentsource_noloading();
    this.api_item_list();
    console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_downloadfile_items();
        break;
      default:
    }
  };

  //////////
  render() {
    const { data, loading, planAcademicYear } = this.state;
    const columns = [
      {
        title: "生源學校地區",
        width: 180,
        children: [
          {
            title: "地區",
            dataIndex: "CountyCityName",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "校數",
            dataIndex: "CountyCityTotal",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
        ],
      },
      {
        title: "生管學院",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "出席",
            dataIndex: "LCollegeYTotal",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#789017";
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: text > 0 ? textColor : "#000000",
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "校數",
            dataIndex: "LCollegeAllTotal",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: {
                    fontWeight: 900,
                  },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "出席率",
            dataIndex: "LCollegeRatio",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: text > 59 ? "green" : text > 0 ? "red" : "#000000",
                  },
                },
                children: <div>{text}%</div>,
              };
            },
          },
        ],
      },
      // {
      //   title: "管理學院",
      //   width: 180,
      //   responsive: ["lg"],
      //   children: [
      //     {
      //       title: "出席",
      //       dataIndex: "MCollegeYTotal",
      //       align: "center",
      //       width: 50,
      //       render(text, record) {
      //         var textColor = "#0061ae";
      //         return {
      //           props: {
      //             style: {
      //               fontWeight: 900,
      //               color: text > 0 ? textColor : "#000000",
      //             },
      //           },
      //           children: <div>{text > 0 ? text : ""}</div>,
      //         };
      //       },
      //     },
      //     {
      //       title: "校數",
      //       dataIndex: "MCollegeAllTotal",
      //       align: "center",
      //       width: 50,
      //       render(text, record) {
      //         return {
      //           props: {
      //             style: { fontWeight: 900 },
      //           },
      //           children: <div>{text}</div>,
      //         };
      //       },
      //     },
      //     {
      //       title: "出席率",
      //       dataIndex: "MCollegeRatio",
      //       align: "center",
      //       width: 50,
      //       render(text, record) {
      //         return {
      //           props: {
      //             style: {
      //               fontWeight: 900,
      //               color: text > 59 ? "green" : text > 0 ? "red" : "#000000",
      //             },
      //           },
      //           children: <div>{text}%</div>,
      //         };
      //       },
      //     },
      //   ],
      // },
      {
        title: "設計學院",
        responsive: ["lg"],
        width: 180,
        children: [
          {
            title: "出席",
            dataIndex: "DCollegeYTotal",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#f08519";
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: text > 0 ? textColor : "#000000",
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "校數",
            dataIndex: "DCollegeAllTotal",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "出席率",
            dataIndex: "DCollegeRatio",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: text > 59 ? "green" : text > 0 ? "red" : "#000000",
                  },
                },
                children: <div>{text}%</div>,
              };
            },
          },
        ],
      },
      {
        title: "藝術學院",
        width: 180,
        responsive: ["lg"],
        children: [
          {
            title: "出席",
            dataIndex: "ACollegeYTotal",
            align: "center",
            width: 50,
            render(text, record) {
              var textColor = "#e40082";
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: text > 0 ? textColor : "#000000",
                  },
                },
                children: <div>{text > 0 ? text : ""}</div>,
              };
            },
          },
          {
            title: "校數",
            dataIndex: "ACollegeAllTotal",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "出席率",
            dataIndex: "ACollegeRatio",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: {
                    fontWeight: 900,
                    color: text > 59 ? "green" : text > 0 ? "red" : "#000000",
                  },
                },
                children: <div>{text}%</div>,
              };
            },
          },
        ],
      },
      // {
      //   title: "旅遊學院",
      //   width: 180,
      //   responsive: ["lg"],
      //   children: [
      //     {
      //       title: "出席",
      //       dataIndex: "TCollegeYTotal",
      //       align: "center",
      //       width: 50,
      //       render(text, record) {
      //         var textColor = "#00706a";
      //         return {
      //           props: {
      //             style: {
      //               fontWeight: 900,
      //               color: text > 0 ? textColor : "#000000",
      //             },
      //           },
      //           children: <div>{text > 0 ? text : ""}</div>,
      //         };
      //       },
      //     },
      //     {
      //       title: "校數",
      //       dataIndex: "TCollegeAllTotal",
      //       align: "center",
      //       width: 50,
      //       render(text, record) {
      //         return {
      //           props: {
      //             style: { fontWeight: 900 },
      //           },
      //           children: <div>{text}</div>,
      //         };
      //       },
      //     },
      //     {
      //       title: "出席率",
      //       dataIndex: "TCollegeRatio",
      //       align: "center",
      //       width: 50,
      //       render(text, record) {
      //         return {
      //           props: {
      //             style: {
      //               fontWeight: 900,
      //               color: text > 59 ? "green" : text > 0 ? "red" : "#000000",
      //             },
      //           },
      //           children: <div>{text}%</div>,
      //         };
      //       },
      //     },
      //   ],
      // },
      {
        title: "合計",
        width: 180,
        children: [
          {
            title: "出席",
            dataIndex: "CountyCityYTotal",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "校數",
            dataIndex: "CountyCityTotal",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "出席率",
            dataIndex: "CollegeRatio",
            align: "center",
            width: 50,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}%</div>,
              };
            },
          },
        ],
      },
    ];

    return (
      <>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",
            marginBottom: "4px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        <button
          className="btn btn-info"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "2px", marginBottom: "4px" }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </button>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(CollegeHandleStatisticesList);
